const data = {
  home: {
    create: "創作",
    list: "創作列表",
    myContent: "我的內容",
    message: "消息",
    notice: "通知",
    creation: "我的創作",
    Setting: "設置",
    logout: "登出",
    language: "語言",
    content1: "請選擇要建立的創作類別",
    content2: "創建遊戲",
    content3: "什麼是實景遊戲",
    address: "佛山市高明區金穗大廈6樓",
    download: "App 下載",
    info1: "關於我們",
    info2: "實景遊戲",
    info3: "智慧導覽",
    info4: "企業合作",
    info5: "創建導覽 / 遊戲",
  },
  edit: {
    backContent: "返回創作列表",
    menu: {
      coverSetting: "封面設計",
      contentEdit: "內容編輯",
      more: "更多",
      plotEditing: "劇情編輯",
      gameEvent: "遊戲事件",
      roleAndScene: "角色和場景",
      bifurcated: "分叉路線",
      gameDesign: "遊戲階級設計",
      collection: "道具收集",
      published: "遊戲發佈",
      storyBackground: "故事背景",
      pointManagement: "積分管理",
      questionnaire: "問卷調查",
    },
    cover: {
      title: "封面介紹",
      save: "保存",
      next: "下一步",
      gameTitle: "遊戲標題",
      gameCategory: "遊戲類別",
      gameLanguage: "遊戲語言",
      difficulty: "難易度",
      playTime: "遊玩時間（分钟）",
      gameCover: "遊戲封面圖",
      gameDescription: "遊戲簡介",
      titleApp: "App示意畫面 - 創作封面",
      app1: "關於",
      app2: "遊戲難度",
      app3: "遊戲時間",
      app4: "地圖導航",
      app5: "介紹",
      opening_hours: "開放時間",
      experience_time: "門票預約",
      begin: "起點",
      end: "終點",
      walking_distance: "步行距離",
      estimated_time: "預估時間",
      Facilities_along_way: "沿途設施",
      multiplayer_game: "多人遊戲",
      player_age: "玩家年齡",
      transportation: "交通方式",
      area: "地区",
      introduction: "介绍视频链接",
      address: "地址",
      tag: "標籤",
      slideshow: "輪播圖: 拖曳排序",
      research_characteristics: "研學特點",
    },
  },
  login: {
    title: "登入",
    username: "使用者名稱",
    usernamePlaceholder: "使用者名稱必須為6到9個非特殊符號的字符",
    password: "密碼",
    passwordPlaceholder: "密碼必須為6到9個非特殊符號的字符",
    submit: "提交",
    switch: "返回登入",
  },
  register: {
    title: "登録",
    switch: "登録に移動",
    submit: "送信",
  },
  settings: {
    title: "設置",
    username: "用戶名",
    password: "密碼",
    language: "語言",
    save: "保存",
    avatar: "头像",
    usernamePlaceholder: "輸入您的用戶名",
    passwordPlaceholder: "輸入您的密碼",
    confirmPassword: "確認密碼",
    newPassword: "新密碼",
    clearImg: "清除圖片",
    back: "返回",
  },
  List: {
    button1: "返回",
    button2: "主頁",
    button3: "編輯",
    button4: "刪除",
    tip: "更新時間",
    deleteInfo: "是否刪除遊戲",
    channel: "取消",
    confirm: "確定",
    creationList: "創作列表",
    trashCan: "垃圾桶",
  },
  Content: {
    tip1: "拖拽排序",
    tip2: "遊戲順序為卡牌順序",
    addLevel: "添加關卡",
    deleteInfo: "是否刪除關卡",
    channel: "取消",
    confirm: "確定",
    gaud: "高德地圖",
    customize: "自定義地圖",
    contentEdit: "內容編輯",
    save: "保存",
  },
  Detail: {
    title: "標題",
    LevelTitle: "關卡標題",
    LevelContent: "關卡謎題內容",
    difficulty: "遊戲難度",
    storeTitle: "故事標題",
    storeContent: "故事內容",
    clues: "遊戲線索（最多上傳3張圖片）",
    answer: "謎題答案",
    tipTitle: "提示標題",
    tipContent: "提示內容",
    back: "返回",
    save: "保存",
  },
};

export default data;
